__turbopack_context__.v({
  "accordionBtn": "ComparisonTray-module-scss-module__3HunLa__accordionBtn",
  "emptyPlanSlot": "ComparisonTray-module-scss-module__3HunLa__emptyPlanSlot",
  "fade": "ComparisonTray-module-scss-module__3HunLa__fade",
  "fade-slide": "ComparisonTray-module-scss-module__3HunLa__fade-slide",
  "navigatingOverlay": "ComparisonTray-module-scss-module__3HunLa__navigatingOverlay",
  "open-from-center": "ComparisonTray-module-scss-module__3HunLa__open-from-center",
  "planContent": "ComparisonTray-module-scss-module__3HunLa__planContent",
  "planName": "ComparisonTray-module-scss-module__3HunLa__planName",
  "planRemove": "ComparisonTray-module-scss-module__3HunLa__planRemove",
  "planRemoving": "ComparisonTray-module-scss-module__3HunLa__planRemoving",
  "planSlots": "ComparisonTray-module-scss-module__3HunLa__planSlots",
  "planSlotsNoBadge": "ComparisonTray-module-scss-module__3HunLa__planSlotsNoBadge",
  "plansContainer": "ComparisonTray-module-scss-module__3HunLa__plansContainer",
  "removeBtn": "ComparisonTray-module-scss-module__3HunLa__removeBtn",
  "rowCollapsed": "ComparisonTray-module-scss-module__3HunLa__rowCollapsed",
  "selectedPlan": "ComparisonTray-module-scss-module__3HunLa__selectedPlan",
  "spin": "ComparisonTray-module-scss-module__3HunLa__spin",
  "title": "ComparisonTray-module-scss-module__3HunLa__title",
  "tray": "ComparisonTray-module-scss-module__3HunLa__tray",
  "trayBadge": "ComparisonTray-module-scss-module__3HunLa__trayBadge",
  "trayClosed": "ComparisonTray-module-scss-module__3HunLa__trayClosed",
  "trayContent": "ComparisonTray-module-scss-module__3HunLa__trayContent",
  "trayWithBadge": "ComparisonTray-module-scss-module__3HunLa__trayWithBadge",
});
